import React, { Component } from "react";
import { alertActions } from '../../action/AlertAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { accountActions } from "../../action/AccountAction";
import { commonClass } from "../../helpers/commonClass";
import { gameActions } from "../../action/GameAction";
import { history } from "../../helpers/history";
import { IframeLoad } from "../Games/IframeLoad";
import TooltipNotes from "../../Tooltip/Tooltip";
import { loginActions } from "../../action/loginAction";
class FreeSpinTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serverDate: new Date(),
            allslotgames: localStorage.getItem('Allslotgames') ? JSON.parse(localStorage.getItem('Allslotgames')) : [],
            amount: "",
            currentPageNo: 0,
            NumberofRecord: 5,
            totalPage: 0,
            startinx: 0,
            endinx: 10,
            lfilterdt: [],
        };
    }

    matchGame = (Obj) => {
        if (this.state.allslotgames && this.state.allslotgames.length > 0) {
            let slgamelocal = this.state.allslotgames;
            let get_single = slgamelocal.filter(a => a.game_type_id == Obj.game_typeid);
            if (get_single && get_single.length > 0) {
                get_single = get_single[0]
                let freewinflag = 1;
                let freewincount = Obj.freespin_count;
                IframeLoad(get_single.game_url, 1, get_single.game_type_id, get_single.category_id, this.props, this.showMsg, freewinflag, freewincount,Obj.bouns_id)
            }
        }
    }

    showMsg = (msg, flag) => {
        this.props.alertError(this.props.t(msg));
    }


    getRandomNumbers() {
        const typedArray = new Uint8Array(5);
        const randomValues = window.crypto.getRandomValues(typedArray);
        return randomValues.join('');
    }

    render() {
        const { t } = this.props;
        let flst = ""
        if (this.props.user_info && this.props.user_info.array && this.props.user_info.array.length > 0) {
            flst = [...new Set(this.props.user_info.array.map(item => item.bouns_id))]
        }
        let StoredArr = [] 
        flst && flst.forEach(element => {
            StoredArr.push(this.props.user_info.array.filter(a => a.bouns_id == element))
        }); 
        return (
            <>
                <div class="myAccContHead">
                    <h1><img src="./assets/img/icons/tabs-wallet.png" />Free Game</h1>
                    <a onClick={() => { this.props.changeFlag(1) }}>{t('lblBack')}</a>
                </div>
                {this.props.user_info && this.props.user_info.array && this.props.user_info.array.length > 0 ?
                    <>
                        <div class="favourites">
                            <div class="latestDrawRslt padding-bottom-0">
                                <ul>
                                    <li>
                                        <div class="w-40 head">{t('lblgame')}</div>
                                        <div class="w-30 head">{t('lblaction')}</div>
                                        <div class="w-30 head">{t('lblfreecount')}</div>
                                    </li>
                                    {
                                        StoredArr && StoredArr.length > 0 && StoredArr.map((x2, inx1) => {
                                            return Array.isArray(StoredArr[inx1]) ? (
                                                <li className="" key={inx1}>
                                                    <div className="w-70">
                                                        {x2.map((x1, inx2) => {
                                                            return (
                                                                <div className="w-100 align-iten-center lto-1" key={inx2}>
                                                                    <div className="w-57 gameName lto-1-text-color">{x1.game_name}</div>
                                                                    <div className="w-43 winBtn" onClick={() => this.matchGame(x1)}>
                                                                        <a className="floatL">{t('lblplay')}</a>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                    <div className="w-30 date">{
                                                        `${StoredArr[inx1][0].freespin_count} - (${StoredArr[inx1][0].bonus_name})`
                                                    }</div>
                                                </li>
                                            ) :
                                                <li className="lto-1" key={inx1}>
                                                    <div className="w-40 gameName lto-1-text-color">{x2.game_name}</div>
                                                    <div className="w-30 winBtn">
                                                        <a className="floatL" onClick={() => this.matchGame(x2)}>{t('lblplay')}</a>
                                                    </div>
                                                    <div className="w-30 date">
                                                        {x2.freespin_count && `${x2.freespin_count} - (${x2.bonus_name})`}
                                                    </div>
                                                </li>
                                        })
                                    }
                                </ul>
                            </div>
                        </div>


                        {/* x1.length > 0 && <td rowspan={x1.length}>{x1.freespin_count}{` - (${(x1.bonus_name)})`}</td>}
                                           <td ><img style={{ width: "100px", height: "60px" }}  
                               src={this.state.allslotgames && this.state.allslotgames.length > 0 &&
                                     this.state.allslotgames.filter(a => a.game_type_id == x1.game_typeid)[0] &&
                                     this.state.allslotgames.filter(a => a.game_type_id == x1.game_typeid)[0].game_icon}
                                 alt={x1.game_name} /></td>
                             <td >
                                 <button className="styled-button" onClick={() => this.matchGame(x1)}>{t('lblplay')}</button>
                             </td>
                             { x1.length > 0 && <td rowspan={x1.length}>{x1.freespin_count}{` - (${(x1.bonus_name)})`}</td> } */}
                        {/* <div class="pagination">
                            <div class="paginationLft">
                                {t('lblshowing')} <span>1</span> {t('lblto')} <span>{this.props.user_info && Math.ceil(this.props.user_info.array.length / this.state.NumberofRecord)}</span> {t('lblof')} <span>{this.props.user_info.array.length}</span> {t('lblentries')}
                            </div>
                            <div class="paginationLRht">
                                <a onClick={() => this.loadnxtdata("first")}><img src="./assets/img/icons/paginate-2-lft.png" /></a>
                                <a class="" onClick={() => this.loadnxtdata("-")}><img src="./assets/img/icons/paginate-1-lft.png" /></a>
                                <a class="" onClick={() => this.loadnxtdata("+")}><img src="./assets/img/icons/paginate-1-rht.png" /></a>
                                <a onClick={() => this.loadnxtdata("last")} class="" ><img src="./assets/img/icons/paginate-2-rht.png" /></a>
                            </div>
                        </div> */}
                    </> :
                    <>
                        <div class="noOrders">
                            <img src="./assets/img/icons/sad.png" />
                            <h3>No Free Spin</h3>
                            <p class="margin-bottom-20">Your Spin is Currently Empty.</p>
                            <div class="formCont updateBtn">
                                <button onClick={() => { history.push("/") }}>{t('lblBactToHome')}</button>
                            </div>
                        </div>

                    </>
                }

            </>
        );
    }
}
function mapStateToProps(state) {
    const { user, appvariables } = state.loginReducer;
    const { TransactionData } = state.accountReducer;
    const { user_info, Amtrestnotes } = state.gameReducer;
    return { user, TransactionData, appvariables, user_info, Amtrestnotes };
}
const mapActionToProps = {
    alertError: alertActions.error,
    Winningtocredits: accountActions.Winningtocredits,
    alertError: alertActions.error,

}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(FreeSpinTab))
